import {getShoppingSubscriptionResultInfo} from '@web/actions/result'
import {BillingPayMethodsKey, PayMethod} from '@web/core/constants'
import {BankEasyPayView, CardEasyPay} from '@web/slices/priorityPaymentMethod/slice'
import makeSlice from '@web/slices/priorityPaymentMethod/sliceMaker'

import {fetchSubscription} from '../../actions'

import {convertCard, convertChargeAccount} from './converter'

const priorityPaymentMethodSlice = makeSlice({
    extraReducers(builder) {
        builder
            .addCase(fetchSubscription.fulfilled, (state, {payload: {paymentMethodsResult}}) => {
                if (paymentMethodsResult) {
                    const {firstPayMethod, secondPayMethod} = paymentMethodsResult

                    /** 1순위 결제수단 */
                    if (firstPayMethod.payMethodType === PayMethod.RECHARGE_POINT) {
                        state.selectedPayment.billingPayMethod = BillingPayMethodsKey.RECHARGE_POINT
                        state.selectedPayment.selectedMethod = PayMethod.RECHARGE_POINT
                        state.selectedPayment.chargeAccount = {accountKey: firstPayMethod.key}

                        state.payMethod.chargedAccounts.push(
                            convertChargeAccount({
                                accountKey: firstPayMethod.key,
                                bankCode: firstPayMethod.corporationCode as BankEasyPayView['bankCode'],
                                bankName: firstPayMethod.corporationName,
                                maskedAccountNumber: firstPayMethod.payMethodDisplayNumber ?? '',
                                invalidReason: firstPayMethod.invalidReason,
                            }),
                        )
                    } else {
                        state.selectedPayment.billingPayMethod = BillingPayMethodsKey.CARD_EASY_PAY
                        state.selectedPayment.selectedMethod = PayMethod.CARD_EASY_PAY
                        state.selectedPayment.cardEasyPay = {cardId: firstPayMethod.key}

                        state.payMethod.cardEasyPays.push(
                            convertCard({
                                cardCompanyCode: firstPayMethod.corporationCode as CardEasyPay['cardCompanyCode'],
                                cardId: firstPayMethod.key,
                                cardImageUrl: firstPayMethod.payMethodImageUrl ?? '',
                                cardName: firstPayMethod.cardName ?? '',
                                maskedCardNumber: firstPayMethod.payMethodDisplayNumber ?? '',
                                invalidReason: firstPayMethod.invalidReason,
                                cardType: firstPayMethod.cardType ?? 'CHECK',
                            }),
                        )
                    }

                    /** 2순위 결제수단 */
                    if (secondPayMethod) {
                        if (secondPayMethod.payMethodType === PayMethod.RECHARGE_POINT) {
                            state.selectedSecondPayment.billingPayMethod = BillingPayMethodsKey.RECHARGE_POINT
                            state.selectedSecondPayment.selectedMethod = PayMethod.RECHARGE_POINT
                            state.selectedSecondPayment.chargeAccount = {accountKey: secondPayMethod.key}

                            state.payMethod.chargedAccounts.push(
                                convertChargeAccount({
                                    accountKey: secondPayMethod.key,
                                    bankCode: secondPayMethod.corporationCode as BankEasyPayView['bankCode'],
                                    bankName: secondPayMethod.corporationName,
                                    maskedAccountNumber: secondPayMethod.payMethodDisplayNumber ?? '',
                                    invalidReason: secondPayMethod.invalidReason,
                                }),
                            )
                        } else {
                            state.selectedSecondPayment.billingPayMethod = BillingPayMethodsKey.CARD_EASY_PAY
                            state.selectedSecondPayment.selectedMethod = PayMethod.CARD_EASY_PAY
                            state.selectedSecondPayment.cardEasyPay = {cardId: secondPayMethod.key}

                            state.payMethod.cardEasyPays.push(
                                convertCard({
                                    cardCompanyCode: secondPayMethod.corporationCode as CardEasyPay['cardCompanyCode'],
                                    cardId: secondPayMethod.key,
                                    cardImageUrl: secondPayMethod.payMethodImageUrl ?? '',
                                    cardName: secondPayMethod.cardName ?? '',
                                    maskedCardNumber: secondPayMethod.payMethodDisplayNumber ?? '',
                                    invalidReason: secondPayMethod.invalidReason,
                                    cardType: firstPayMethod.cardType ?? 'CHECK',
                                }),
                            )
                        }
                    }
                }
            })
            .addCase(getShoppingSubscriptionResultInfo.fulfilled, (state, {payload}) => {
                const {firstPayMethod, secondPayMethod} = payload.paymentMethodsInfo

                /** 1순위 결제수단 */
                if (firstPayMethod.payMethodType === PayMethod.RECHARGE_POINT) {
                    state.selectedPayment.billingPayMethod = BillingPayMethodsKey.RECHARGE_POINT
                    state.selectedPayment.selectedMethod = PayMethod.RECHARGE_POINT
                    state.selectedPayment.chargeAccount = {accountKey: firstPayMethod.key}

                    state.payMethod.chargedAccounts.push(
                        convertChargeAccount({
                            accountKey: firstPayMethod.key,
                            bankCode: firstPayMethod.corporationCode as BankEasyPayView['bankCode'],
                            bankName: firstPayMethod.corporationName,
                            maskedAccountNumber: firstPayMethod.payMethodDisplayNumber ?? '',
                            invalidReason: firstPayMethod.invalidReason,
                        }),
                    )
                } else {
                    state.selectedPayment.billingPayMethod = BillingPayMethodsKey.CARD_EASY_PAY
                    state.selectedPayment.selectedMethod = PayMethod.CARD_EASY_PAY
                    state.selectedPayment.cardEasyPay = {cardId: firstPayMethod.key}

                    state.payMethod.cardEasyPays.push(
                        convertCard({
                            cardCompanyCode: firstPayMethod.corporationCode as CardEasyPay['cardCompanyCode'],
                            cardId: firstPayMethod.key,
                            cardImageUrl: firstPayMethod.payMethodImageUrl ?? '',
                            cardName: firstPayMethod.cardName ?? '',
                            maskedCardNumber: firstPayMethod.payMethodDisplayNumber ?? '',
                            invalidReason: firstPayMethod.invalidReason,
                            cardType: firstPayMethod.cardType ?? 'CHECK',
                        }),
                    )
                }

                /** 2순위 결제수단 */
                if (secondPayMethod) {
                    if (secondPayMethod.payMethodType === PayMethod.RECHARGE_POINT) {
                        state.selectedSecondPayment.billingPayMethod = BillingPayMethodsKey.RECHARGE_POINT
                        state.selectedSecondPayment.selectedMethod = PayMethod.RECHARGE_POINT
                        state.selectedSecondPayment.chargeAccount = {accountKey: secondPayMethod.key}

                        state.payMethod.chargedAccounts.push(
                            convertChargeAccount({
                                accountKey: secondPayMethod.key,
                                bankCode: secondPayMethod.corporationCode as BankEasyPayView['bankCode'],
                                bankName: secondPayMethod.corporationName,
                                maskedAccountNumber: secondPayMethod.payMethodDisplayNumber ?? '',
                                invalidReason: firstPayMethod.invalidReason,
                            }),
                        )
                    } else {
                        state.selectedSecondPayment.billingPayMethod = BillingPayMethodsKey.CARD_EASY_PAY
                        state.selectedSecondPayment.selectedMethod = PayMethod.CARD_EASY_PAY
                        state.selectedSecondPayment.cardEasyPay = {cardId: secondPayMethod.key}

                        state.payMethod.cardEasyPays.push(
                            convertCard({
                                cardCompanyCode: secondPayMethod.corporationCode as CardEasyPay['cardCompanyCode'],
                                cardId: secondPayMethod.key,
                                cardImageUrl: secondPayMethod.payMethodImageUrl ?? '',
                                cardName: secondPayMethod.cardName ?? '',
                                maskedCardNumber: secondPayMethod.payMethodDisplayNumber ?? '',
                                invalidReason: secondPayMethod.invalidReason,
                                cardType: secondPayMethod.cardType ?? 'CHECK',
                            }),
                        )
                    }
                }
            })
    },
})
export default priorityPaymentMethodSlice.reducer

export const actions = priorityPaymentMethodSlice.actions
